<div *adaptLoading="!authorizations">
    @if (errorMessage) {
        <div class="alert alert-danger mb-0">{{ errorMessage }}</div>
    } @else if (authorizations?.length === 0) {
        <p class="mb-0">You have not authorised any applications to access Lumia.</p>
    } @else {
        <div class="d-flex flex-column gap-3">
            @for (authorization of authorizations; track authorization.ClientId) {
                <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
                    <div>
                        <div class="fw-semibold">{{ authorization.DisplayName }}</div>
                        @if (authorization.DisplayName !== authorization.ClientId) {
                            <small class="text-muted">{{ authorization.ClientId }}</small>
                        }
                        <div class="small text-muted">Authorised {{ authorization.LastAuthorizedAt | date: "medium" }}</div>
                    </div>
                    <button class="btn btn-outline-danger align-self-start align-self-md-center"
                            [adaptBlockingClick]="revokeAuthorization"
                            [adaptBlockingClickParam]="authorization">Revoke access</button>
                </div>
            }
        </div>
    }
</div>
